import { isNullOrUndefined } from '@smart-builder/util';
import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CRSupplierBody,
  CRSupplierBodyAPI,
  CRSupplierKey,
  CRSupplierSummary,
  CRSupplierSummaryAPI,
  SuppliersActions,
  SuppliersState,
} from './types';

type AnySupplier =
  | CRSupplierKey
  | CRSupplierSummary
  | CRSupplierBody
  | undefined;

function sameKeySupplier(a: AnySupplier, b: AnySupplier): boolean {
  return a?.supplierId === b?.supplierId;
}

function getEndpointSupplier(key: AnySupplier): string {
  return key ? `/suppliers/${key.supplierId}/` : '/suppliers/';
}

function parseSupplierSummary(
  supplierSummary: CRSupplierSummaryAPI,
): CRSupplierSummary {
  return supplierSummary;
}

function parseSupplierBody(CRSupplierBody: CRSupplierBodyAPI): CRSupplierBody {
  return CRSupplierBody;
}

function mergeSupplierBody(
  lastBody: CRSupplierBody,
  currentBody: CRSupplierBody,
) {
  return currentBody;
}

const suppliersStateSelector = (state: any): SuppliersState => state.suppliers;
const suppliersKeySelector = ({
  supplierId,
}: CRSupplierSummary | CRSupplierBody): CRSupplierKey => ({ supplierId });

function combineSummaryBodySupplier(
  summary?: CRSupplierSummary,
  detail?: CRSupplierBody,
): CRSupplierSummary {
  const merge = mergeSummaryBodyField(summary, detail);
  return {
    supplierId: merge('supplierId'),
    supplierName: merge('supplierName'),
    scope: merge('scope'),
    isActive: isNullOrUndefined(detail?.isActive?.server.value)
      ? !!summary?.isActive
      : merge('isActive'),
    isActiveForSite: isNullOrUndefined(detail?.isActiveForSite?.server.value)
      ? !!summary?.isActiveForSite
      : merge('isActiveForSite'),
    childAccess: merge('childAccess'),
    isGlassSupplier: merge('isGlassSupplier'),
    rowKey: merge('rowKey'),
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'suppliers',
  getEndpointSupplier,
  suppliersStateSelector,
  sameKeySupplier,
  parseSupplierBody,
  parseSupplierSummary,
  mergeSupplierBody,
  combineSummaryBodySupplier,
  // formatSupplierBody,
  // validateSuppliers,
);

const suppliersActions: SuppliersActions = actions;
export * from './types';
export {
  suppliersActions,
  reducer as suppliersReducer,
  watches as suppliersWatches,
  suppliersStateSelector,
  suppliersKeySelector,
};
